const MarkdownExampleResult = `
[Skip to content](#site-content)[Skip to site index](#site-index)

[SKIP ADVERTISEMENT](#after-dfp-ad-top)

* [U.S.](/)
* [International](/international/)
* [Canada](/ca/)
* [Español](https://www.nytimes.com/es/)
* [中文](https://cn.nytimes.com)

[Today’s Paper](https://www.nytimes.com/section/todayspaper)

* [U.S.](https://www.nytimes.com/section/us)  
### Sections  
   * [U.S.](https://www.nytimes.com/section/us)  
   * [Politics](https://www.nytimes.com/section/politics)  
   * [New York](https://www.nytimes.com/section/nyregion)  
   * [California](https://www.nytimes.com/spotlight/california-news)  
   * [Education](https://www.nytimes.com/section/education)  
   * [Health](https://www.nytimes.com/section/health)  
   * [Obituaries](https://www.nytimes.com/section/obituaries)  
   * [Science](https://www.nytimes.com/section/science)  
###  
   * [Climate](https://www.nytimes.com/section/climate)  
   * [Weather](https://www.nytimes.com/section/weather)  
   * [Sports](https://www.nytimes.com/section/sports)  
   * [Business](https://www.nytimes.com/section/business)  
   * [Tech](https://www.nytimes.com/section/technology)  
   * [The Upshot](https://www.nytimes.com/section/upshot)  
   * [The Magazine](https://www.nytimes.com/section/magazine)  
### Top Stories  
   * [Trump Transition](https://www.nytimes.com/news-event/trump-transition)  
   * [Supreme Court](https://www.nytimes.com/topic/organization/us-supreme-court)  
   * [Congress](https://www.nytimes.com/topic/organization/us-congress)  
   * [Immigration](https://www.nytimes.com/news-event/immigration-us)  
   * [Abortion](https://www.nytimes.com/spotlight/abortion-news)  
### Newsletters  
   * [![The Morning Logo](/vi-assets/static-assets/icon-the-morning_144x144-b12a6923b6ad9102b766352261b1a847.webp)The MorningMake sense of the day’s news and ideas.](https://www.nytimes.com/newsletters/morning-briefing)  
   * [![The Upshot Logo](/vi-assets/static-assets/icon-the-upshot_144x144-0b1553ff703bbd07ac8fe73e6d215888.webp)The UpshotAnalysis that explains politics, policy and everyday life.](https://www.nytimes.com/newsletters/upshot)  
[See all newsletters](https://www.nytimes.com/newsletters)  
### Podcasts  
   * [![The Daily Logo](https://static01.nyt.com/images/2017/01/29/podcasts/the-daily-album-art/the-daily-album-art-mediumSquare149-v3.jpg?quality=75&auto=webp&disable=upscale)The DailyThe biggest stories of our time, in 20 minutes a day.](https://www.nytimes.com/column/the-daily)  
   * [![The Run-Up Logo](https://static01.nyt.com/images/2022/08/29/podcasts/the-run-up-album-art/the-run-up-album-art-thumbLarge.jpg?quality=75&auto=webp&disable=upscale)The Run-UpOn the campaign trail with Astead Herndon.](https://www.nytimes.com/column/election-run-up-podcast)  
[See all podcasts](https://www.nytimes.com/spotlight/podcasts)
* [World](https://www.nytimes.com/section/world)  
### Sections  
   * [World](https://www.nytimes.com/section/world)  
   * [Africa](https://www.nytimes.com/section/world/africa)  
   * [Americas](https://www.nytimes.com/section/world/americas)  
   * [Asia](https://www.nytimes.com/section/world/asia)  
   * [Australia](https://www.nytimes.com/section/world/australia)  
   * [Canada](https://www.nytimes.com/section/world/canada)  
   * [Europe](https://www.nytimes.com/section/world/europe)  
   * [Middle East](https://www.nytimes.com/section/world/middleeast)  
   * [Science](https://www.nytimes.com/section/science)  
   * [Climate](https://www.nytimes.com/section/climate)  
   * [Weather](https://www.nytimes.com/section/weather)  
   * [Health](https://www.nytimes.com/section/health)  
   * [Obituaries](https://www.nytimes.com/section/obituaries)  
### Top Stories  
   * [Middle East Crisis](https://www.nytimes.com/news-event/israel-hamas-gaza)  
   * [Russia-Ukraine War](https://www.nytimes.com/news-event/ukraine-russia)  
   * [China International Relations](https://www.nytimes.com/spotlight/china-relations)  
   * [The Global Profile](https://www.nytimes.com/column/the-global-profile)  
   * [Leer en Español](https://www.nytimes.com/es/)  
### Newsletters  
   * [![Morning Briefing: Europe Logo](/vi-assets/static-assets/icon-europe-morning-briefing_144x144-f0a330cb12ba0c31f81f13e25f6d0d18.webp)Morning Briefing: EuropeGet what you need to know to start your day.](https://www.nytimes.com/newsletters/morning-briefing-europe)  
   * [![The Interpreter Logo](/vi-assets/static-assets/icon-the-interpreter_144x144-b29b74b2ebedb8e74823f33b16fb8167.webp)The InterpreterOriginal analysis on the week’s biggest global stories.](https://www.nytimes.com/newsletters/the-interpreter)  
###  
   * [![Your Places: Global Update Logo](/vi-assets/static-assets/icon-yourplaces-globalupdate_144x144-c25aba1c2904f301a08ad33183f723c6.webp)Your Places: Global UpdateThe latest news for any part of the world you select.](https://www.nytimes.com/newsletters/your-places-global-update)  
   * [![Canada Letter Logo](/vi-assets/static-assets/icon-canada-letter_144x144-65d899377edbcce9773d31fd03a77e8d.webp)Canada LetterBackstories and analysis from our Canadian correspondents.](https://www.nytimes.com/newsletters/canada-letter)  
[See all newsletters](https://www.nytimes.com/newsletters)
* [Business](https://www.nytimes.com/section/business)  
### Sections  
   * [Business](https://www.nytimes.com/section/business)  
   * [Tech](https://www.nytimes.com/section/technology)  
   * [Economy](https://www.nytimes.com/section/business/economy)  
   * [Media](https://www.nytimes.com/section/business/media)  
   * [Finance and Markets](https://www.nytimes.com/section/markets-overview)  

.....  
`;



  export default MarkdownExampleResult;
